import React, { Component } from "react";
import ReactJson from "react-json-view";

const PrettyPrintJson = props => {
  return (
    <div>
      <ReactJson
        src={props.data}
        displayDataTypes={props.displayDataTypes}
        collapsed={props.collapsed}
      />
    </div>
  );
};

export default PrettyPrintJson;
